import { useLocalizable } from '@contexts/LocalizableContext'
import { CommunicationKey } from '@models/Communication'
import { requiredRule } from '@utils/rules'
import { Alert, Button, Col, Flex, Form, Row, Space, Typography } from 'antd'
import { Localizable } from '../../../localizable/Localizable'
import { ContentWrapper } from '../components/ContentWrapper'
import { IphoneModule } from '../components/IphoneModule'
import { SendTestModal } from '../components/SendTestModal'
import { StepProps } from '../types'
const { Title } = Typography

// Same bound as the API: each text lands in a varchar(255) column.
export const PUSH_TEXT_MAX_LENGTH = 255

export const Content = ({ onPrev, onFinish }: StepProps) => {
  const localizable = useLocalizable()
  const form = Form.useFormInstance()

  const id = Form.useWatch('id')
  const title = Form.useWatch([localizable?.langCode, 'title'])
  const subtitle = Form.useWatch([localizable?.langCode, 'subtitle'])
  const body = Form.useWatch([localizable?.langCode, 'body'])

  return (
    <>
      <Row>
        <Col span={12}>
          <ContentWrapper>
            <Space className="w-full space-between">
              <Title className="m-0" level={5}>
                Add the push content
              </Title>
              <Localizable.LangSelector type="segment" />
            </Space>
            <Localizable.Input
              name={'title'}
              label={'Title'}
              max={PUSH_TEXT_MAX_LENGTH}
            />
            <Localizable.Input
              name={'subtitle'}
              label={'Subtitle'}
              max={PUSH_TEXT_MAX_LENGTH}
            />
            <Localizable.TextArea
              name={'body'}
              label={'Body'}
              max={PUSH_TEXT_MAX_LENGTH}
              rules={[requiredRule()]}
            />
            <Alert
              title="The body for each language is the only required field. We recommend completing one language at a time to ensure accurate input."
              type="info"
              showIcon
            />
          </ContentWrapper>
        </Col>
        <Col span={12}>
          <IphoneModule title={title} subtitle={subtitle} body={body} />
        </Col>
      </Row>

      <Flex justify="space-between" gap={8}>
        <SendTestModal
          communicationKey={CommunicationKey.NOTIFICATION_PUSH_CAMPAIGN}
          context={{ notification: id }}
          wizardFormInstance={form}
          bypassTestCommunicationsFlag
          disabled={!id}
          disabledReason="Save the notification before sending a test."
        />
        <Space>
          <Button type="default" onClick={onPrev} disabled={false}>
            Prev
          </Button>
          <Button
            type="primary"
            onClick={onFinish}
            disabled={
              form.getFieldValue(['fr', 'body']) === '' ||
              form.getFieldValue(['fr', 'body']) === undefined ||
              form.getFieldValue(['en', 'body']) === '' ||
              form.getFieldValue(['en', 'body']) === undefined
            }
          >
            Finish
          </Button>
        </Space>
      </Flex>
    </>
  )
}
